<template>
  <div class="ps-container">
    <div>
      <aside class="ps-sidebar-modern">
        <h3 class="ps-sidebar-title">Filtros</h3>
        <div v-for="g in groups" :key="g.key" class="ps-sidebar-group">
          <button class="ps-group-header" @click="toggleGroup(g.key)">
            {{ g.label }}
            <i
              :class="
                openGroup === g.key
                  ? 'mdi mdi-minus'
                  : 'mdi mdi-plus'
              "
            />
          </button>
          
          <transition name="expand">
            <div v-show="openGroup === g.key" class="ps-group-body">
               <!-- BUSCADOR INTERNO DESKTOP -->
               <div v-if="['categoria', 'marca', 'estante'].includes(g.key)" class="ps-sidebar-search-modern">
                  <i class="mdi mdi-magnify"></i>
                  <input 
                    v-model="filterSearch[g.key]" 
                    type="text" 
                    :placeholder="'Buscar...'"
                  />
               </div>
  
               <ul class="ps-modern-list">
                  <li v-for="opt in getFilteredOptions(g.key)" :key="opt.value || opt">
                    <button
                      :class="{ selected: isActive(g.key, opt) }"
                      @click="select(g.key, opt, 'desktop')"
                    >
                      <span class="custom-checkbox"></span>
                      <span class="opt-text">{{ optLabel(g.key, opt) }}</span>
                    </button>
                  </li>
                   <li v-if="getFilteredOptions(g.key).length === 0" class="p-2 text-grey">
                      Sin resultados
                  </li>
                </ul>
            </div>
          </transition>
        </div>
      </aside>
    </div>
    <!-- CONTENIDO -->
    <main class="ps-main">
      <!-- CONTROLES MÓVIL -->
      <!-- CONTROLES MÓVIL (BOTÓN FILTRAR Y ORDENAR) -->
      <div class="ps-mobile-actions">
        <button class="ps-btn-filter-toggle" @click="showMobileFilters = true">
           <i class="mdi mdi-filter-variant"></i> Filtrar y Ordenar
        </button>
        
        <!-- Chips de filtros activos (Horizontal Scroll) -->
        <div class="ps-mobile-active-filters" v-if="hasActiveFilters">
           <span v-if="selected.tipo !== 'Todos'" class="filter-chip">
              {{ selected.tipo }} <i class="mdi mdi-close" @click="select('tipo', 'Todos')"></i>
           </span>
           <span v-if="selected.categoria !== 'Todos'" class="filter-chip">
              {{ selected.categoria }} <i class="mdi mdi-close" @click="select('categoria', 'Todos')"></i>
           </span>
           <span v-if="selected.marca !== 'Todos'" class="filter-chip">
              Marca: {{ selected.marca }} <i class="mdi mdi-close" @click="select('marca', 'Todos')"></i>
           </span>
           <span v-if="selected.estante !== 'Todos' && esUsuarioInterno" class="filter-chip">
              Estante: {{ selected.estante }} <i class="mdi mdi-close" @click="select('estante', 'Todos')"></i>
           </span>
        </div>
      </div>
      <!-- LISTAS MÓVILES -->
      <!-- LISTAS MÓVILES (DRAWER / OFF-CANVAS) -->
      <transition name="fade">
        <div class="ps-mobile-overlay" v-if="showMobileFilters" @click="showMobileFilters = false"></div>
      </transition>
      
      <div class="ps-mobile-drawer" :class="{ open: showMobileFilters }">
        <div class="ps-drawer-header">
          <h3>Filtros</h3>
          <button @click="showMobileFilters = false"><i class="mdi mdi-close"></i></button>
        </div>
        <div class="ps-drawer-content">
           <div v-for="g in groups" :key="g.key" class="ps-filter-group-mobile">
              <button class="ps-drawer-accordion-btn" @click="toggleGroup(g.key)" :class="{ active: openGroup === g.key }">
                 {{ g.label }}
                 <i :class="openGroup === g.key ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'"></i>
              </button>
              
              <div v-show="openGroup === g.key" class="ps-drawer-group-content">
                  <!-- Buscador Móvil -->
                  <div v-if="['categoria', 'marca', 'estante'].includes(g.key)" class="ps-drawer-search">
                     <i class="mdi mdi-magnify"></i>
                     <input 
                       v-model="filterSearch[g.key]" 
                       type="text" 
                       :placeholder="'Buscar ' + g.label.toLowerCase() + '...'"
                       @click.stop
                     />
                  </div>
                  
                  <ul class="ps-drawer-list">
                    <li v-for="opt in getFilteredOptions(g.key)" :key="opt.value || opt">
                      <button 
                         @click="select(g.key, opt, 'mobile'); showMobileFilters = false"
                         :class="{ selected: isActive(g.key, opt) }"
                      >
                         <span class="check-circle"></span>
                         {{ optLabel(g.key, opt) }}
                      </button>
                    </li>
                    <li v-if="getFilteredOptions(g.key).length === 0" class="p-2 text-grey">
                        No hay resultados
                    </li>
                  </ul>
              </div>
           </div>
        </div>
      </div>

      <!-- GRID DE PRODUCTOS -->
      <!-- BUSCADOR VISIBLE SIEMPRE -->
      <div class="ps-store-topbar">
        <div class="ps-store-heading">
          <button
            v-if="filtroCategoriaActiva"
            class="ps-back-category"
            type="button"
            @click="limpiarFiltroCategoria"
            aria-label="Volver a toda la tienda"
          >
            <i class="mdi mdi-chevron-left"></i>
          </button>
          <div>
            <h1>{{ filtroCategoriaActiva || 'Tienda Maxica' }}</h1>
            <span>{{ totalProductos }} productos</span>
          </div>
        </div>
        <div class="ps-buscador-header">
             <div class="ps-buscador-wrapper-full">
               <i class="mdi mdi-magnify ps-icon-search"></i>
               <input
                  v-model="busqueda"
                  type="text"
                  class="ps-buscador-input-full"
                  placeholder="Buscar por producto, marca o codigo"
                  @input="filtrarProductos"
               />
             </div>
        </div>
      </div>

      <transition name="fade">
        <div v-if="filtroCategoriaActiva" class="ps-filtro-activo">
          Mostrando categoría:
          <strong>{{ filtroCategoriaActiva }}</strong>
          <button
            class="ps-filtro-cerrar"
            type="button"
            @click="limpiarFiltroCategoria"
            aria-label="Quitar filtro de categoría"
          >
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </transition>

      <div v-if="loading && !productos.length" class="ps-loading">Cargando…</div>
      <div v-else class="ps-grid">
        <div
          v-for="p in productos"
          :key="p.id"
          class="ps-card"
          :class="{ 'mayorista-card': esMayorista }"
          @click="verDetalle(p)"
        >
          <div class="ps-image-wrapper">
            <img :src="getImage(p)" :alt="p.nombre" class="ps-image" />
            <button
              class="ps-share-card"
              type="button"
              title="Copiar link del producto"
              @click.stop="copiarLinkProducto(p)"
            >
              <i class="mdi mdi-link-variant"></i>
            </button>
            <div
              v-if="esAdmin && imageIsPlaceholder(p)"
              class="sin-imagen-label"
            >
              SIN IMAGEN
            </div>
          </div>
          <div class="ps-info">
            <h3 class="ps-title-card">{{ p.nombre }}</h3>
            <p class="ps-code">{{ p.codigo }}</p>
            <p
              v-if="mostrarUbicacion"
              class="ps-location"
              title="Ubicación en bodega"
            >
              Ubicación: <strong>{{ p.estante || 'Sin estante' }}</strong>
            </p>
          </div>
          <div class="ps-footer ps-discount-footer">
            <template v-if="precioDisponible(precioOferta(p))">

              <div class="ps-price-row">
                <span class="ps-price-current">${{ formatoPrecio(precioOferta(p)) }}</span>
                <span v-if="porcentajeDescuento(p)" class="ps-price-before">
                  ${{ formatoPrecio(precioOriginal(p)) }}
                </span>
              </div>
              <div v-if="porcentajeDescuento(p)" class="ps-discount-note">
                {{ porcentajeDescuento(p) }}% de descuento
              </div>

              <div v-if="precioDisponible(p.precioMayoreo)" class="ps-dozen-price">
                Docena(x12): ${{ formatoPrecio(p.precioMayoreo) }}
              </div>

            </template>
            <div v-else class="ps-price ps-price-consultar">
              Consultar precio
            </div>
          </div>

          <!-- Versión para usuarios no mayoristas -->
          <!-- ADMIN STOCK SUMMARY -->
           <div v-if="esAdmin && p.tallasPorImagen" class="admin-stock-summary" @click.stop>
              <div v-for="(tallas, imgKey) in p.tallasPorImagen" :key="imgKey" class="admin-stock-row">
                  <img :src="absPath(p[imgKey])" class="admin-thumb" :title="imgKey" />
                  <div class="admin-tallas-list">
                      <span v-for="(t, idx) in tallas" :key="idx" 
                            class="admin-stock-badge"
                            :class="{'no-stock': t.existencia <= 0, 'has-stock': t.existencia > 0}">
                          {{ t.talla }}:{{ t.existencia }}
                      </span>
                  </div>
              </div>
           </div>
        </div>
        <div v-if="!loading && !productos.length" class="ps-no-products">
          No hay productos para esta selección.
        </div>
      </div>
      
      <!-- LOAD MORE BUTTON -->
      <!-- INFINITE SCROLL SENTINEL -->
      <div ref="infiniteScrollTrigger" class="ps-infinite-scroll-trigger">
          <div v-if="loadingMore" class="ps-loading-more-spinner">
              <i class="mdi mdi-loading mdi-spin"></i> Cargando más productos...
          </div>
      </div>
    </main>
  </div>
</template>

<script>
import HttpService from "@/Servicios/HttpService";
import MetricaService from "@/Servicios/MetricaService";
export default {
  data() {
    return {
      busqueda: "",
      productos: [],
      totalProductos: 0,
      page: 0,
      limit: 20,
      loading: false,
      loadingMore: false,
      
      filtrosDisponibles: {
        categorias: [],
        tipos: [],
        marcas: [],
        estantes: []
      },

      selected: { tipo: "Todos", categoria: "Todos", marca: "Todos", orden: null, estante: "Todos" },
      visitaId: null,
      inicioVisita: null,
      filterSearch: { categoria: "", marca: "", estante: "" },
      showMobileFilters: false,
      currentUserRole: localStorage.getItem("rol") || "",
      openGroup: null, 
    };
  },
  computed: {
    groups() {
      const g = [
        { key: "tipo", label: "Tipo" },
        { key: "categoria", label: "Categorías" },
        { key: "marca", label: "Marcas" },
        { key: "orden", label: "Ordenar" },
      ];
      if (this.esUsuarioInterno) {
        g.push({ key: "estante", label: "Estantes" });
      }
      return g;
    },
    options() {
      const f = this.filtrosDisponibles || {};
      const tipos = Array.isArray(f.tipos) ? f.tipos : [];
      const categorias = Array.isArray(f.categorias) ? f.categorias : [];
      const marcas = Array.isArray(f.marcas) ? f.marcas : [];
      const estantes = Array.isArray(f.estantes) ? f.estantes : [];
      
      return {
        tipo: ["Todos", ...tipos],
        categoria: ["Todos", ...categorias],
        marca: ["Todos", ...marcas],
        estante: ["Todos", ...estantes],
        orden: [
          { label: "Precio menor a mayor", value: "asc" },
          { label: "Precio mayor a menor", value: "desc" },
          { label: "A → Z", value: "alpha" },
          { label: "Z → A", value: "alphaDesc" },
        ],
      };
    },
    // Removidos computed: tipos, categorias, estantes...

    filtroCategoriaActiva() {
      const categoria = this.selected.categoria;
      return categoria && categoria !== "Todos" ? categoria : null;
    },
    
    filteredSorted() {
        return this.productos;
    },

    esMayorista() {
      const rol = localStorage.getItem("rol");
      return (
        rol === "mayorista" ||
        rol === "administrador" ||
        rol === "cajero" ||
        rol === "inven"
      );
    },
    esAdmin() {
      // Return true if rol is administrador
      return this.currentUserRole === "administrador";
    },
    esUsuarioInterno() {
      return ["administrador", "cajero", "inven"].includes(this.currentUserRole);
    },
    mostrarUbicacion() {
      return !!localStorage.getItem("rol");
    },
    hasActiveFilters() {
        return this.selected.tipo !== 'Todos' || 
               this.selected.categoria !== 'Todos' || 
               this.selected.marca !== 'Todos' ||
               (this.esUsuarioInterno && this.selected.estante !== 'Todos');
    }
  },

  methods: {
    // Carga inicial de filtros
    async cargarFiltros() {
        try {
            const res = await HttpService.obtenerConConsultas("productos.php", {
                accion: "obtenerFiltrosUnicos",
                esAdmin: this.esAdmin
            });
            if (res) {
                // Ensure deep reactivity replacement
                this.filtrosDisponibles = {
                    categorias: res.categorias || [],
                    tipos: res.tipos || [],
                    marcas: res.marcas || [],
                    estantes: res.estantes || []
                };
                // Force update to ensure computed properties re-evaluate immediately
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            }
        } catch (e) {
            console.error("Error cargando filtros:", e);
        }
    },

    // Cargar productos con paginación y filtros
    async cargarProductos(append = false) {
        if (append) {
            this.loadingMore = true;
            this.page += 1;
        } else {
            this.loading = true;
            this.page = 0;
            this.productos = []; // Limpiar si es nueva búsqueda
        }

        const offset = this.page * this.limit;
        
        const payload = {
            accion: "listasProductos",
            limit: this.limit,
            offset: offset,
            busqueda: this.busqueda,
            tipo: this.selected.tipo,
            categoria: this.selected.categoria,
            marca: this.selected.marca,
            estante: this.esUsuarioInterno ? this.selected.estante : "Todos",
            orden: this.selected.orden,
            esAdmin: this.esAdmin
        };

        try {
            const res = await HttpService.obtenerConConsultas("productos.php", payload);
            const nuevosProductos = res.productos || [];
            this.totalProductos = parseInt(res.total || 0);

            if (append) {
                this.productos = [...this.productos, ...nuevosProductos];
            } else {
                this.productos = nuevosProductos;
            }
        } catch (e) {
            console.error("Error cargando productos:", e);
        } finally {
            this.loading = false;
            this.loadingMore = false;
        }
    },
    
    // Al cambiar cualquier filtro
    aplicarFiltros() {
        this.cargarProductos(false); // Reinicia listado
        // Cerrar drawer móvil si está abierto
        // this.showMobileFilters = false; // (Opcional, depende UX)
    },

    // desplazamiento suave
    scrollLeft() {
      this.$refs.carousel.scrollBy({ left: -120, behavior: "smooth" });
    },
    scrollRight() {
      this.$refs.carousel.scrollBy({ left: 120, behavior: "smooth" });
    },
    isMobileActive(key) {
      const val = this.selected[key];
      return val && val !== "Todos" && val !== null;
    },
    toggleGroup(k) {
      this.openGroup = this.openGroup === k ? null : k;
    },
    select(k, opt, where) {
      this.selected[k] = k === "orden" ? opt.value : opt;
      if (where === "mobile") this.openGroup = null;
      if (k === "categoria") {
        this.actualizarRutaCategoria(this.selected.categoria);
      }
      this.aplicarFiltros(); // Recargar productos con nuevo filtro
    },
    isActive(k, opt) {
      return k === "orden"
        ? this.selected.orden === opt.value
        : this.selected[k] === opt;
    },
    filtrarProductos() {
      // Debounce para búsqueda texto
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
          this.contextoBusqueda = "texto"; // flag opcional
          this.aplicarFiltros();
      }, 500);
    },


    optLabel(k, opt) {
      return k === "orden" ? opt.label : opt;
    },
    mobileLabel(k) {
      const sel = this.selected[k];
      if (k === "orden") {
        const o = this.options.orden.find((x) => x.value === sel);
        return o ? `Ordenar: ${o.label}` : "Ordenar";
      }
      return sel && sel !== "Todos"
        ? `${this.groups.find((g) => g.key === k).label}: ${sel}`
        : this.groups.find((g) => g.key === k).label;
    },
    getFilteredOptions(key) {
      if (key === 'orden') return this.options[key];
      
      const term = this.filterSearch[key] ? this.filterSearch[key].toLowerCase() : "";
      const list = this.options[key] || [];
      
      if (!term) return list;
      return list.filter(opt => String(opt).toLowerCase().includes(term));
    },
    placeholderProductoUrl() {
      return "img/sin-fotos-maxica.svg";
    },
    esImagenPlaceholder(r) {
      const limpia = String(r || "").trim().toLowerCase();
      return (
        !limpia ||
        limpia.includes("sinimagen") ||
        limpia.includes("sin-foto") ||
        limpia.includes("sinfoto") ||
        limpia.includes("placeholder") ||
        limpia.includes("megapos")
      );
    },
    absPath(r) {
      if (this.esImagenPlaceholder(r)) {
        return this.placeholderProductoUrl();
      }
      const ruta = String(r);
      return ruta.includes("http")
        ? ruta
        : ruta.replace("../api/", "https://maxica.com.co/ximena/api/");
    },
    imagenValida(r) {
      return !!(r && !this.esImagenPlaceholder(r));
    },
    imageTieneStock(producto, key) {
      const tallas = producto?.tallasPorImagen?.[key];
      if (!Array.isArray(tallas) || tallas.length === 0) {
        return true;
      }
      return tallas.some((t) => Number(t.existencia || 0) > 0);
    },
    getImagenPrincipal(producto) {
      const imagenes = [];
      for (let i = 1; i <= 10; i++) {
        const key = `imagen${i}`;
        const img = producto[key];
        if (this.imagenValida(img)) {
          imagenes.push({ key, img });
        }
      }
      if (!imagenes.length && this.imagenValida(producto.imagen)) {
        imagenes.push({ key: "imagen1", img: producto.imagen });
      }

      return (
        imagenes.find((item) => this.imageTieneStock(producto, item.key)) ||
        imagenes[0] ||
        null
      );
    },
    images(p) {
      const imgs = [];
      for (let i = 1; i <= 10; i++) {
        const img = p[`imagen${i}`];
        if (this.imagenValida(img)) {
          imgs.push(img);
        }
      }
      if (!imgs.length && this.imagenValida(p.imagen)) {
        imgs.push(p.imagen);
      }
      return imgs;
    },
    getImage(p) {
      const principal = this.getImagenPrincipal(p);
      if (principal) return this.absPath(principal.img);
      return this.absPath(null);
    },
    imageIsPlaceholder(p) {
      const url = this.getImage(p);
      return this.esImagenPlaceholder(url);
    },
    precioDisponible(precio) {
      return Number(precio || 0) > 0;
    },
    precioOferta(producto) {
      return this.precioDisponible(producto.precioVenta)
        ? producto.precioVenta
        : producto.precioVenta2;
    },
    precioOriginal(producto) {
      return producto.precioVenta2;
    },
    porcentajeDescuento(producto) {
      const oferta = Number(this.precioOferta(producto) || 0);
      const original = Number(this.precioOriginal(producto) || 0);
      if (!oferta || !original || original <= oferta) return 0;
      return Math.round(((original - oferta) / original) * 100);
    },
    formatoPrecio(precio) {
      return Number(precio || 0).toLocaleString("es-CO");
    },
    slugify(valor) {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "") || "producto";
    },
    verDetalle(producto) {
      this.guardarEstadoCatalogo();
      this.$router.push({
        name: "ProductoDetalle",
        params: { id: producto.id, slug: this.slugify(producto.nombre || producto.codigo) }
      });
    },
    urlProducto(producto) {
      const ruta = this.$router.resolve({
        name: "ProductoDetalle",
        params: { id: producto.id, slug: this.slugify(producto.nombre || producto.codigo) }
      });
      return `${window.location.origin}${window.location.pathname}${ruta.href}`;
    },
    async copiarTexto(texto) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(texto);
        return;
      }
      const input = document.createElement("textarea");
      input.value = texto;
      input.style.position = "fixed";
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      input.remove();
    },
    async copiarLinkProducto(producto) {
      await this.copiarTexto(this.urlProducto(producto));
    },
    estadoCatalogoKey() {
      return "maxicaCatalogoWebEstado";
    },
    guardarEstadoCatalogo(routeFullPath = this.$route.fullPath) {
      const estado = {
        routeFullPath,
        busqueda: this.busqueda,
        selected: { ...this.selected },
        filterSearch: { ...this.filterSearch },
        page: this.page,
        productosLength: this.productos.length,
        scrollY: window.scrollY || document.documentElement.scrollTop || 0,
        timestamp: Date.now(),
      };
      sessionStorage.setItem(this.estadoCatalogoKey(), JSON.stringify(estado));
    },
    obtenerEstadoCatalogo() {
      try {
        const estado = JSON.parse(sessionStorage.getItem(this.estadoCatalogoKey()) || "null");
        if (!estado || estado.routeFullPath !== this.$route.fullPath) return null;
        const maxEdad = 30 * 60 * 1000;
        if (Date.now() - Number(estado.timestamp || 0) > maxEdad) return null;
        return estado;
      } catch (e) {
        return null;
      }
    },
    restaurarControlesCatalogo(estado) {
      this.busqueda = estado.busqueda || "";
      this.selected = {
        ...this.selected,
        ...(estado.selected || {}),
      };
      this.filterSearch = {
        ...this.filterSearch,
        ...(estado.filterSearch || {}),
      };
    },
    async cargarProductosHastaEstado(estado) {
      const paginaObjetivo = Math.max(0, Number(estado.page || 0));
      const productosObjetivo = Math.max(this.limit, Number(estado.productosLength || 0));
      await this.cargarProductos(false);
      while (
        this.page < paginaObjetivo &&
        this.productos.length < this.totalProductos &&
        this.productos.length < productosObjetivo
      ) {
        await this.cargarProductos(true);
      }
    },
    restaurarScrollCatalogo(scrollY) {
      const destino = Math.max(0, Number(scrollY || 0));
      const aplicar = () => window.scrollTo({ top: destino, left: 0, behavior: "auto" });
      this.$nextTick(() => {
        aplicar();
        setTimeout(aplicar, 80);
        setTimeout(aplicar, 300);
      });
    },
    resolverCategoriaDesdeRuta() {
      if (this.$route.name === "CatalogoCategoria" && this.$route.params.slug) {
        const slug = this.$route.params.slug;
        const encontrada = (this.filtrosDisponibles.categorias || []).find(
          cat => this.slugify(cat) === slug
        );
        return encontrada || null;
      }
      return this.$route.query.categoria || null;
    },
    actualizarRutaCategoria(valor) {
      const nueva = !valor || valor === "Todos" ? null : valor;

      if (nueva) {
        const slug = this.slugify(nueva);
        if (this.$route.name === "CatalogoCategoria" && this.$route.params.slug === slug) return;
        this.$router.replace({ name: "CatalogoCategoria", params: { slug } }).catch(() => {});
      } else {
        if (this.$route.name === "CatalogoWeb" && !this.$route.query.categoria) return;
        this.$router.replace({ name: "CatalogoWeb" }).catch(() => {});
      }
    },
    establecerCategoriaDesdeRuta(categoria) {
      this.selected.categoria = categoria || "Todos";
      this.aplicarFiltros(); // Load on route change if cat set
    },
    limpiarFiltroCategoria() {
      if (this.filtroCategoriaActiva) {
        this.selected.categoria = "Todos";
        this.actualizarRutaCategoria("Todos");
        this.aplicarFiltros();
      }
    },
    async enviarRegistroVisita() {
      this.inicioVisita = Date.now();
      let ciudad = null;
      let pais = null;
      try {
        const res = await fetch("https://ipapi.co/json/");
        const geo = await res.json();
        ciudad = geo.city;
        pais = geo.country_name;
      } catch (e) {
        // ignora errores de geolocalización
      }
      const resp = await MetricaService.registrarVisita({
        ruta: this.$route.fullPath,
        referrer: document.referrer,
        ciudad,
        pais,
      });
      this.visitaId = resp?.id || null;
      if (this.visitaId) {
        sessionStorage.setItem("visitaId", this.visitaId);
      }
    },
    registrarTiempo() {
      if (!this.visitaId) return;
      const duracion = Math.round((Date.now() - this.inicioVisita) / 1000);
      MetricaService.registrarTiempoVisita({
        visita_id: this.visitaId,
        duracion,
      });
    },
    setupInfiniteScroll() {
        const options = {
            root: null, // viewport
            rootMargin: '100px', // Pre-cargar antes de llegar al final
            threshold: 0.1
        };
        
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // Verify productos exists to avoid 'length' error
                if (entry.isIntersecting && !this.loading && !this.loadingMore && this.productos && this.productos.length < this.totalProductos) {
                    this.cargarProductos(true);
                }
            });
        }, options);
        
        if (this.$refs.infiniteScrollTrigger) {
            this.observer.observe(this.$refs.infiniteScrollTrigger);
        }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "ProductoDetalle") {
      this.guardarEstadoCatalogo(from.fullPath);
    }
    next();
  },
  async mounted() {
    await this.cargarFiltros(); // Load filters first

    const estadoGuardado = this.obtenerEstadoCatalogo();
    if (estadoGuardado) {
      this.restaurarControlesCatalogo(estadoGuardado);
      await this.cargarProductosHastaEstado(estadoGuardado);
      this.restaurarScrollCatalogo(estadoGuardado.scrollY);
    } else {
      // Check route query
      this.selected.categoria = this.resolverCategoriaDesdeRuta() || "Todos";
      await this.cargarProductos(); // Load initial products
    }

    this.enviarRegistroVisita();
    window.addEventListener("beforeunload", this.registrarTiempo);
    
    // Configurar IntersectionObserver para Infinite Scroll
    this.setupInfiniteScroll();
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.registrarTiempo);
    this.registrarTiempo();
    if (this.observer) {
        this.observer.disconnect();
    }
  },
  watch: {

    "$route.fullPath": {
      handler() {
        const categoria = this.resolverCategoriaDesdeRuta() || "Todos";
        if (this.selected.categoria === categoria) return;

        this.selected.categoria = categoria;
        this.aplicarFiltros();
      },
    },
  },
};
</script>

<style scoped>
.ps-store-topbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee8e0;
}

.ps-store-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.ps-store-heading h1 {
  margin: 0;
  color: #111111;
  font-size: 1.75rem;
  line-height: 1.1;
  font-weight: 850;
  letter-spacing: 0;
}

.ps-store-heading span {
  display: block;
  margin-top: 4px;
  color: #706861;
  font-size: 0.92rem;
  font-weight: 600;
}

.ps-back-category {
  width: 38px;
  height: 38px;
  border: 1px solid #e0d8cf;
  background: #fff;
  color: #111;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  flex: 0 0 auto;
}

.ps-filtro-activo {
  position: sticky;
  top: 12px;
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
  border-radius: 999px;
  background: rgba(44, 115, 210, 0.12);
  color: #1e293b;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
}

.ps-filtro-activo strong {
  color: #0f172a;
}

.ps-filtro-cerrar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: #2c73d2;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
}

.ps-filtro-cerrar:hover {
  background: #1d4ed8;
}

.ps-filtro-cerrar i {
  font-size: 18px;
  line-height: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.ps-buscador-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  position: relative;
}

.ps-buscador-lupa {
  background: none;
  border: none;
  font-size: 1.7rem;
  color: #333;
  cursor: pointer;
  outline: none;
}

.ps-buscador-input {
  border: 1.5px solid #c7d7ee;
  background: #fff;
  border-radius: 6px;
  padding: 7px 16px;
  font-size: 1.07rem;
  outline: none;
  transition: box-shadow 0.19s;
  width: 220px;
  margin-left: 7px;
  box-shadow: 0 2px 10px 0 rgba(44, 115, 210, 0.05);
  font-family: "Poppins", Arial, sans-serif;
  display: inline-block;
}

.ps-buscador-input:focus {
  border-color: #2c73d2;
  box-shadow: 0 4px 18px 0 rgba(44, 115, 210, 0.07);
}

/* SEARCH FULL WIDTH */
.ps-buscador-header {
  margin-bottom: 0;
  width: min(100%, 560px);
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.ps-buscador-wrapper-full {
  position: relative;
  width: 100%;
  max-width: 560px;
}
.ps-icon-search {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 1.2rem;
  pointer-events: none;
}
.ps-buscador-input-full {
  width: 100%;
  padding: 12px 12px 12px 42px; /* Espacio para el icono */
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  outline: none;
  font-size: 0.95rem;
  transition: all 0.2s;
  background: #fff;
  color: #334155;
  box-shadow: none;
}
.ps-buscador-input-full:focus {
  border-color: #111111;
  box-shadow: 0 0 0 3px rgba(17, 17, 17, 0.08);
}

/* --- DESKTOP FILTERS BAR --- */
.desktop-filters {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  position: relative; /* Contexto de apilamiento */
  z-index: 50; /* Por encima de todo */
  flex-wrap: wrap;
}

.dd-wrapper {
  position: relative;
}

.dd-button {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
  font-size: 0.95rem;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.dd-button:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.dd-button.active {
  background: #eff6ff;
  border-color: #2c73d2;
  color: #2c73d2;
}

.dd-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 6px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  min-width: 200px;
  z-index: 100;
  overflow: hidden;
  padding: 6px;
  display: flex;
  flex-direction: column;
}

.ps-infinite-scroll-trigger {
    height: 60px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}
.ps-loading-more-spinner {
    color: #2c73d2;
    font-size: 1rem;
    font-weight: 500;
}

.dd-menu button {
  text-align: left;
  background: none;
  border: none;
  padding: 8px 12px;
  width: 100%;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #334155;
  transition: background 0.1s;
}

.dd-menu button:hover {
  background: #f1f5f9;
}

.dd-menu button.selected {
  background: #eff6ff;
  color: #2c73d2;
  font-weight: 600;
}

/* Dropdown con búsqueda */
.dd-menu.with-search {
  min-width: 260px;
  padding: 0;
}

.dd-search-box {
  padding: 10px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8fafc;
}

.dd-search-box i {
  color: #94a3b8;
  font-size: 1.1rem;
}

.dd-search-box input {
  border: none;
  background: transparent;
  width: 100%;
  outline: none;
  font-size: 0.9rem;
  color: #334155;
}

.dd-scroll-area {
  max-height: 280px;
  overflow-y: auto;
  padding: 6px;
}

.dd-scroll-area button {
  margin-bottom: 2px;
}

/* Custom scrollbar for dropdown */
.dd-scroll-area::-webkit-scrollbar {
  width: 6px;
}
.dd-scroll-area::-webkit-scrollbar-track {
  background: transparent;
}
.dd-scroll-area::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 20px;
}


.ps-container {
  display: flex;
}

.ps-filter-group + .ps-filter-group {
  margin-top: 24px;
}
/* Estilo para el select de estantes */
.ps-select-estante {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: white;
  font-size: 0.9rem;
  color: #333;
}
.ps-filter-header {
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  font-weight: bold;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.ps-filter-list {
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
}
.ps-filter-list li + li {
  margin-top: 8px;
}
.ps-filter-list button {
  width: 100%;
  border: none;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.ps-filter-list button.active,
.ps-filter-list button:hover {
  background: #4caf50;
  color: #fff;
}



/* ---- MODERN SIDEBAR (DESKTOP) ---- */
.ps-sidebar-modern {
  position: fixed;
  left: 16px;
  top: 120px; /* Ajustado para no chocar con el header (20px top + header height) */
  bottom: 24px; 
  width: 260px; 
  background: #fff;
  z-index: 100; /* Asegurar que este sobre el contenido principal pero bajo el header */
  padding: 24px 16px;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: none;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.ps-sidebar-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f1f5f9;
  color: #1e293b;
}
.ps-sidebar-group {
  margin-bottom: 16px;
  border-bottom: 1px solid #f8fafc;
  padding-bottom: 16px;
}
.ps-group-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: none;
  border: none;
  font-size: 0.95rem;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  padding: 4px 0;
}
.ps-group-body {
  margin-top: 12px;
}
.ps-sidebar-search-modern {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 10px;
  margin-bottom: 10px;
}
.ps-sidebar-search-modern i {
  color: #94a3b8;
  margin-right: 6px;
}
.ps-sidebar-search-modern input {
  border: none;
  background: transparent;
  width: 100%;
  outline: none;
  font-size: 0.85rem;
  color: #475569;
}
.ps-modern-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 250px; /* Scroll interno si es muy largo */
  overflow-y: auto;
  scrollbar-width: thin;
}
.ps-modern-list button {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 4px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s;
  color: #64748b;
}
.ps-modern-list button:hover {
  color: #111111;
}
.ps-modern-list button .custom-checkbox {
  width: 16px;
  height: 16px;
  border: 2px solid #cbd5e1;
  border-radius: 4px;
  display: inline-block;
  position: relative;
}
.ps-modern-list button.selected .custom-checkbox {
  background: #111111;
  border-color: #111111;
}
.ps-modern-list button.selected .custom-checkbox::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.ps-modern-list button.selected .opt-text {
  color: #0f172a;
  font-weight: 500;
}

.ps-main {
  margin-left: 280px; /* Sidebar width + gap */
  padding: 24px 28px;
  flex: 1;
}

/* OCULTAR CONTROLES MÓVIL EN DESKTOP */
@media (min-width: 768px) {
  .ps-mobile-carousel-wrapper,
  .ps-mobile-dropdown,
  .ps-mobile-actions,
  .ps-mobile-drawer,
  .ps-mobile-overlay {
    display: none !important;
  }
}

/* ---- MOBILE DRAWER & ACTIONS ---- */
.ps-mobile-actions {
  display: none; /* Desktop hidden */
}

@media (max-width: 767px) {
  .ps-store-topbar {
    display: block;
    margin-bottom: 14px;
    padding-bottom: 12px;
  }

  .ps-store-heading {
    margin-bottom: 12px;
  }

  .ps-store-heading h1 {
    font-size: 1.35rem;
  }

  .ps-buscador-header {
    width: 100%;
    display: block;
  }

  .ps-buscador-wrapper-full {
    max-width: none;
  }

  .ps-sidebar-modern {
    display: none;
  }
  .ps-main {
    margin-left: 0;
    padding: 16px;
  }
  
  .ps-mobile-actions {
    display: block;
    margin-bottom: 16px;
  }
  .ps-btn-filter-toggle {
    width: 100%;
    background: #fff;
    border: 1px solid #e2e8f0;
    padding: 12px;
    border-radius: 8px;
    font-weight: 600;
    color: #334155;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }
  .ps-btn-filter-toggle:active {
    background: #f1f5f9;
  }
  
  .ps-mobile-active-filters {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding: 10px 0 0 0;
    scrollbar-width: none;
  }
  .filter-chip {
    background: #f4efe8;
    color: #111111;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
  }
  .filter-chip i { cursor: pointer; }

  /* DRAWER */
  .ps-mobile-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 11000;
  }
  .ps-mobile-drawer {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0; 
    width: 85%;
    max-width: 320px;
    background: white;
    z-index: 11001;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 20px rgba(0,0,0,0.1);
  }
  .ps-mobile-drawer.open {
    transform: translateX(0);
  }
  .ps-drawer-header {
    padding: 16px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ps-drawer-header h3 {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 700;
  }
  .ps-drawer-content {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }
  
  .ps-filter-group-mobile {
    border-bottom: 1px solid #f1f5f9;
    padding-bottom: 12px;
    margin-bottom: 12px;
  }
  .ps-drawer-accordion-btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background: none;
    border: none;
    padding: 8px 0;
    font-weight: 600;
    font-size: 1rem;
    color: #1e293b;
  }
  .ps-drawer-search {
    background: #f8fafc;
    padding: 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    margin: 8px 0;
  }
  .ps-drawer-search input {
    border: none;
    background: transparent;
    width: 100%;
    outline: none;
    margin-left: 8px;
  }
  .ps-drawer-list {
    list-style: none;
    padding: 0;
    margin-top: 8px;
  }
  .ps-drawer-list button {
    width: 100%;
    padding: 10px 4px;
    text-align: left;
    background: none;
    border: none;
    font-size: 0.95rem;
    color: #475569;
    display: flex; /* Checkboxes visuals */
    gap: 10px;
    align-items: center;
  }
  .ps-drawer-list button .check-circle {
      width: 18px; height: 18px;
      border-radius: 50%;
      border: 2px solid #cbd5e1;
      display: block;
  }
  .ps-drawer-list button.selected .check-circle {
      border-color: #2c73d2;
      background: #111111;
      box-shadow: inset 0 0 0 3px white;
  }
  .ps-drawer-list button.selected {
      color: #0f172a;
      font-weight: 500;
  }
}

/* Animations */
.expand-enter-active, .expand-leave-active {
  transition: all 0.25s ease-out;
  max-height: 500px;
  opacity: 1;
}
.expand-enter, .expand-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

/* Grid & cards (igual al código anterior) */
.ps-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 16px;
}
.ps-loading {
  padding: 40px 0;
  text-align: center;
  color: #666;
}
.ps-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, 1fr); /* siempre al menos 2 */
}

@media (min-width: 480px) {
  .ps-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 640px) {
  .ps-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1024px) {
  .ps-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1280px) {
  .ps-grid {
    grid-template-columns: repeat(6, 1fr);
  } /* tope en 6 */
}

.ps-card {
  background: #fff;
  border: 1px solid #e9e4dc;
  border-radius: 6px;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s, transform 0.2s;
}
.ps-card:hover {
  border-color: #111111;
  transform: translateY(-2px);
}
.ps-image-wrapper {
  position: relative;
  width: 100%;
  padding-top: 112%;
  background: #f4f4f4;
}
.ps-share-card {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #1b365d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.16);
}
.ps-share-card:hover {
  background: #1b365d;
  color: #fff;
}
.ps-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 10px;
  transition: transform 0.3s;
}
.ps-card:hover .ps-image {
  transform: scale(1.025);
}
.sin-imagen-label {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-weight: bold;
  font-size: 0.9rem;
}
.ps-info {
  padding: 12px;
  flex: 1;
}
.ps-title-card {
  font-size: 0.95rem;
  line-height: 1.25;
  margin: 0 0 4px;
  min-height: 2.4em;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ps-code {
  font-size: 0.85rem;
  color: #777;
  margin: 0;
}
.ps-location {
  margin: 6px 0 0;
  font-size: 0.9rem;
  color: #0f172a;
}
.ps-location strong {
  color: #1f2937;
}
.ps-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-top: 1px solid #f0f0f0;
}
.ps-discount-footer {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 3px;
  min-height: 86px;
}
.ps-price-row {
  display: flex;
  align-items: baseline;
  gap: 7px;
  max-width: 100%;
}
.ps-price-current {
  font-size: 1rem;
  line-height: 1.15;
  font-weight: 800;
  color: #111;
}
.ps-price-before {
  font-size: 0.82rem;
  color: #868686;
  text-decoration: line-through;
  white-space: nowrap;
}
.ps-discount-note {
  font-size: 0.78rem;
  line-height: 1.2;
  font-weight: 700;
  color: #15803d;
}
.ps-dozen-price {
  margin-top: 2px;
  font-size: 0.78rem;
  line-height: 1.2;
  font-weight: 600;
  color: #315a3d;
}
.ps-price {
  font-size: 1.1rem;
  font-weight: bold;
  color: #222;
}
.ps-price-consultar {
  font-size: 0.95rem;
  font-weight: 700;
  color: #8a5b00;
}
.ps-no-products {
  grid-column: 1/-1;
  text-align: center;
  color: #666;
  margin-top: 16px;
}

.ps-mobile-carousel-wrapper {
  max-width: 100vw; /* 👈 límite absoluto: no se pasa del ancho de la pantalla */
  overflow-x: auto; /* permite scroll si es necesario */
  padding: 8px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  white-space: nowrap; /* 👈 evita salto de línea */
  scrollbar-width: none;
}

.ps-mobile-carousel-wrapper::-webkit-scrollbar {
  display: none;
}
/* Por defecto ocultamos el carrusel */
.ps-mobile-carousel-wrapper {
  display: none;
}

/* Solo en pantallas pequeñas (móvil) lo mostramos */
@media (max-width: 767px) {
  .ps-mobile-carousel-wrapper {
    display: block;
  }
}

.ps-mobile-carousel-wrapper button {
  display: inline-block;
  max-width: 250px;
  margin-right: 8px;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f9f9f9;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.ps-mobile-carousel-wrapper button.active {
  background: #2c73d2;
  color: white;
  border-color: #2c73d2;
}

/*Para mayoristas*/
.ps-price-docena {
  font-size: 12px;
  color: #2c73d2;
  margin-top: 4px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.mayorista-footer {
  border-top: 1px solid #ccc;
  padding-top: 6px;
}

/* Borde degradado para cards de mayorista */
.precio-mayorista-card {
  position: relative;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.esquina-degradada {
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
  background: linear-gradient(
    135deg,
    rgba(0, 23, 46, 0.9),
    rgba(72, 0, 84, 0.8),
    rgba(125, 0, 0, 0.8)
  );
  clip-path: polygon(100% 0, 100% 100%, 0 0%);
  border-top-right-radius: 6px;
}

/* Precio principal (mayorista) */
.ps-precio-mayorista {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 4px;
}

/* Precio por docena en bloque separado */
.ps-docena-bloque {
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
}

/* ADMIN SUMMARY STYLES */
.admin-stock-summary {
  margin: 0 10px 10px 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px;
  font-size: 0.8rem;
  max-height: 120px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.admin-stock-summary::-webkit-scrollbar {
  width: 4px;
}
.admin-stock-summary::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.admin-stock-row {
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px dashed #e2e8f0;
  padding-bottom: 4px;
}
.admin-stock-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.admin-thumb {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ddd;
  flex-shrink: 0;
}
.admin-tallas-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.admin-stock-badge {
  display: inline-block;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 0.7rem;
  font-weight: 600;
  background: #eef2ff;
  color: #334155;
  border: 1px solid #e2e8f0;
}
.admin-stock-badge.has-stock {
  background: #dcfce7;
  color: #166534;
  border-color: #bbf7d0;
}
.admin-stock-badge.no-stock {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
  opacity: 0.7;
}

.ps-label-docena {
  font-size: 12px;
  color: #2c73d2;
  margin-bottom: 2px;
}

.ps-docena-numero {
  font-size: 14px;
  color: #1b365d;
  font-weight: 600;
}

.ps-docena-numero.no-disponible {
  color: #999;
  font-style: italic;
}

/* Precio detal chico */
.ps-detalle-chico {
  font-size: 11px;
  color: #888;
  margin-top: 2px;
}
</style>
